// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
export const createAdminVendorBuyingOrders = (client) => ({
    /**
     * `GET /admin/vendor-buying-orders`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminVendorBuyingOrdersList
     * @source packages/modules/b2c-core/src/api/admin/vendor-buying-orders/route.ts
     */
    list: (query, headers) => client.fetch("/admin/vendor-buying-orders", { method: "GET", query, headers }),
});
//# sourceMappingURL=vendor-buying-orders.js.map